import request from "../request";



// Add Tag
export const addTagDetails = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("tag/", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Edit Tag Details By Id
export const editTagDetailsById = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`tag/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Edit Product Array For Tag  By Id
export const editTagProductArrayById = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`tag/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Get Tag List
export const getTagList = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/tag`, { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Get Tag Details By Id
export const getTagDetailsById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`tag/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Delete Tag Details By Id
export const deleteTag = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`tag/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

